<tui-doc-main>
    <ng-container ngProjectAs="tuiDocHeader">
        <a
            href="https://www.npmjs.com/package/ng-morph"
            rel="noreferrer"
            target="_blank"
            class="npm-link"
        >
            <img
                alt="npm-link"
                src="https://img.shields.io/npm/dy/ng-morph?color=gainsboro&style=flat-square"
            />
        </a>

        <!-- TODO: (Taiga UI migration) TuiMode has been removed. Please use tuiTheme attribute to set theme https://taiga-ui.dev/directives/theme -->
        <a
            href="https://github.com/taiga-family/ng-morph"
            rel="noreferrer"
            target="_blank"
            tuiLink
            tuiTheme="light"
            class="github-link"
        >
            <img
                alt=""
                src="assets/images/github.svg"
                class="github"
            />
            GitHub
        </a>
    </ng-container>
</tui-doc-main>
